import Repository from './Repository'
import { API_BASE_PATH } from './ApiPath'

const ADMIN = API_BASE_PATH.ADMIN

export default {
  getSeasons(queries: any) {
    return Repository.get(`${ADMIN}/season`, { params: queries })
  },
  getSeason(season_id: number) {
    return Repository.get(`${ADMIN}/season/${season_id}`)
  },
  postSeason(data: any) {
    return Repository.post(`${ADMIN}/season`, data)
  },
  updateSeason(data: any) {
    return Repository.put(`${ADMIN}/season`, data)
  },
  archiveSeason(data: any) {
    return Repository.put(`${ADMIN}/season/archive`, data)
  },
  deleteSeason(params: any) {
    return Repository.delete(`${ADMIN}/season`, { data: params })
  }
}